import type { AxiosResponse } from 'axios';
import { defineStore } from 'pinia';
import { getFaq } from '~/composables/services/faq';

export const useGlobalStore = defineStore('globalStore', {
  state: () => ({
    faqs: [] as Array<FaqInterface>,
    loadingFaqs: false as boolean,
  }),

  getters: {
    getFaq: (state) => state.faqs,
    getLoadingFaqState: (state) => state.loadingFaqs,
  },

  actions: {
    async getFaqs(creditorKey?: string) {
      this.loadingFaqs = true;

      let params: object = { 'limite': 1000, 'ordem': 'ordem' };

      if (creditorKey) {
        params = { ...params, 'chave_empresa': creditorKey };
      }

      try {
        var request: AxiosResponse<paginaTionResponse> = await getFaq(params);
        var unclassifiedFaqs = request?.data?.objects ?? [];

        this.faqs = unclassifiedFaqs.reduce((total: any, currentValue: any) => {
          total[currentValue.categoria] = [...total[currentValue.categoria] || [], currentValue];
          return total;
        }, {});
      } catch (e) {
        Promise.reject(e)
      }

      this.loadingFaqs = false;
    },
  },
})